const updatesData = [
  { time: '刚刚', title: '某选秀节目导师被爆收受选手贿赂，节目组紧急声明', tag: '最新' },
  { time: '5分钟前', title: '知名导演被多名女演员联合举报不当行为', tag: '重磅' },
  { time: '18分钟前', title: '某头部带货主播直播间被封，疑因税务问题被查', tag: '热议' },
  { time: '32分钟前', title: '热播剧男二被拍到与制片人深夜聚餐引发换角猜测', tag: '' },
  { time: '45分钟前', title: '网红餐厅后厨卫生问题被曝光，多地被责令整改', tag: '跟进' },
  { time: '1小时前', title: '某女团队内霸凌事件持续升级，经纪公司沉默引众怒', tag: '' },
  { time: '1.5小时前', title: '知名电竞选手涉嫌假赛被联盟终身禁赛', tag: '重磅' },
  { time: '2小时前', title: '某影视公司涉嫌阴阳合同被税务部门约谈', tag: '' },
  { time: '3小时前', title: '综艺节目录制中嘉宾受伤，安全措施遭质疑', tag: '' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[880px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 relative">
            <i className="ri-radar-fill text-accent-600 text-xl"></i>
            <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-primary-500 rounded-full animate-pulse"></span>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            最新动态
          </h2>
          <span className="text-xs text-primary-500 font-medium bg-primary-100 px-2.5 py-1 rounded-full whitespace-nowrap animate-pulse">
            LIVE
          </span>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300"></div>
          <div className="space-y-1">
            {updatesData.map((item, idx) => (
              <div key={idx} className="flex items-start gap-4 py-3 relative group cursor-pointer">
                <span className={`relative z-10 shrink-0 w-[38px] h-[38px] flex items-center justify-center rounded-full mt-0.5 ${
                  idx === 0 ? 'bg-primary-500 text-background-50' :
                  idx <= 2 ? 'bg-primary-100 text-primary-600' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`${
                    idx === 0 ? 'ri-notification-3-fill' :
                    idx <= 2 ? 'ri-fire-fill' : 'ri-record-circle-line'
                  } text-sm`}></i>
                </span>
                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                    {item.tag && (
                      <span className={`text-xs px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                        item.tag === '重磅'
                          ? 'bg-primary-500 text-background-50'
                          : item.tag === '最新'
                          ? 'bg-accent-500 text-background-50'
                          : 'bg-accent-100 text-accent-700'
                      }`}>
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}